export default __webpack_public_path__ + "static/image-56-09c74c9f8d10efea184d8af35bf690c9.jpg";